export default "__VITE_ASSET__CUrNb1dM__"